import { createFileRoute, Link } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@ecom/ui/card';
import { Button } from '@ecom/ui/button';
import { trpc } from '@/index';
import { MarketplaceBadge } from '@/components/marketplace-badge';
import { ShopStatusBadge } from '@/components/shop-status-badge';

export const Route = createFileRoute('/(app)/shops/')({
  component: ShopsPage,
});

function ShopsPage() {
  const [shops] = trpc.shop.list.useSuspenseQuery();

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Shops</h1>
          <p className="text-muted-foreground">{shops.length} connected</p>
        </div>
        <Button asChild>
          <Link to="/shops/new">Add shop</Link>
        </Button>
      </div>

      {shops.length === 0 ? (
        <Card>
          <CardContent className="p-8 text-center">
            <p className="text-muted-foreground mb-3">No shops connected.</p>
            <Button asChild>
              <Link to="/shops/new">Connect your first shop</Link>
            </Button>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4">
          {shops.map((shop) => (
            <Card key={shop.id}>
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-lg">{shop.shopName}</CardTitle>
                  <div className="flex items-center gap-2">
                    <MarketplaceBadge type={shop.marketplaceType} region={shop.region} />
                    <ShopStatusBadge status={shop.status} />
                  </div>
                </div>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Last synced: {shop.lastSyncedAt ? new Date(shop.lastSyncedAt).toLocaleString() : 'never'}
                {shop.lastError && (
                  <div className="mt-1 text-destructive">{shop.lastError}</div>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
